import { useEffect, useState } from 'react'
import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { ChangeEvent } from '@bm-js/atlascloud-shared'

export type CourseInitial = {
  name: string
}

type Props = {
  data?: CourseInitial
  handleSubmit: (
    data: CourseInitial,
    success: () => void,
    error: () => void
  ) => void
  closePopup: () => void
}

const CourseForm = ({ data, handleSubmit, closePopup }: Props) => {
  const { tr } = useTr()

  const initialUser: CourseInitial = {
    name: '',
  }

  const [formData, setFormData] = useState<CourseInitial>(initialUser)
  const [loading, setLoading] = useState(false)

  const handleChange = (e: ChangeEvent) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  useEffect(() => {
    // eslint-disable-next-line
    if (data) setFormData(data)
  }, [data])

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        setLoading(true)
        handleSubmit(
          formData,
          () => {
            setLoading(false)
            setFormData(initialUser)
          },
          () => {
            setLoading(false)
          }
        )
      }}
    >
      <h1 className='m0 primblue mbottom1'>{tr(TrKey.createCourse)}</h1>
      <Input
        label={tr(TrKey.name)}
        desc={tr(TrKey.courseNameDescription)}
        required
        disabled={loading}
        type='text'
        value={formData.name}
        name='name'
        placeholder={tr(TrKey.courseNamePlaceholder)}
        onChange={handleChange}
      />
      <div className='jce gap1 flex'>
        <Button type='submit' disabled={loading}>
          {loading ? tr(TrKey.saving) : tr(TrKey.save)}
        </Button>
        <Button danger disabled={loading} onClick={closePopup}>
          {tr(TrKey.cancel)}
        </Button>
      </div>
    </form>
  )
}

export default CourseForm
